module.exports = __webpack_public_path__ + "media/assets/images/logo_energia-0c38b13ad79247f4c2139cec4513afe0.jpg";